<template>
  <div class="banner">
    <div class="container">
      <a-row>
        <a-col :xs="24" :xl="12">
          <a-typography-title :level="1">
            重磅发布！
          </a-typography-title>
          <a-typography-title :level="5">
            《星汉未来DevOps工程效率及运维解决方案白皮书》
          </a-typography-title>
          <a-typography-paragraph>
            云原生时代，全面云架构的新一代 DevOps 工具全景图<br>
            打造适配不同体量、不同阶段企业的工程效能及基础治理综合解决方案
          </a-typography-paragraph>
          <a-space>
            <a-button type="link" class="button_1"
                      @click="download(href.book)">
              点击下载
            </a-button>
          </a-space>
        </a-col>
      </a-row>
    </div>
  </div>
  <section v-for="v in expand.list" class="section">
    <div class="container">
      <a-typography-title v-if="v.title" :level="1">
        {{ v.title }}
      </a-typography-title>
      <a-typography-paragraph v-if="v.text">
        {{ v.text }}
      </a-typography-paragraph>
      <img v-if="v.image" alt=""
           :src="v.image" />
    </div>
  </section>
  <section class="section">
    <div class="container">
      <a-typography-paragraph class="text">
        如需体验SchedulX，感受1分钟1000台的极速扩容能力，
        或了解SchedulX的更多强大功能，欢迎扫描下方二维码联系我们，
        或填写<a :href="href.apply" target="_blank">试用申请</a>，
        将有技术专家为您提供量身定制的高效运维建议。
      </a-typography-paragraph>
      <img class="qr" alt=""
           :src="file.ImageQR" />
      <a-button type="link" class="button_1"
                @click="download(href.book)">
        查看完整报告
      </a-button>
    </div>
  </section>
  <section class="section box_href">
    <div class="container">
      <a-typography-title :level="2">
        云原生基础治理平台SchedulX相关资料
      </a-typography-title>
      <a-button type="link" class="button_1" target="_blank"
                :href="href.introduce">
        产品介绍视频
      </a-button>
      <a-button type="link" class="button_1" target="_blank"
                :href="href.operate">
        操作说明视频
      </a-button>
      <a-button type="link" class="button_1"
                @click="$RQ.GoGSS()">
        免费试用
      </a-button>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';
import Image_1 from '@resource/image/book/devOps/1.png';
import Image_2 from '@resource/image/book/devOps/2.png';
import Image_3 from '@resource/image/book/devOps/3.png';
import Image_4 from '@resource/image/book/devOps/4.png';
import Image_5 from '@resource/image/book/devOps/5.png';
import ImageQR from '@resource/image/public/qr_assistant.jpg';

export default {
  name: 'book_devOps',
  props: [
    'download'
  ],
  data(): DataInterface {
    return {
      href: {
        book: 'https://gf-files-lf.oss-cn-beijing.aliyuncs.com/%E6%98%9F%E6%B1%89%E6%9C%AA%E6%9D%A5DevOps%E5%B7%A5%E7%A8%8B%E6%95%88%E7%8E%87%E5%8F%8A%E8%BF%90%E7%BB%B4%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88%E7%99%BD%E7%9A%AE%E4%B9%A6.pdf',
        github: 'https://github.com/galaxy-future/schedulx',
        apply: 'https://wj.qq.com/s2/10019525/fb2a',
        introduce: 'https://www.bilibili.com/video/BV1K3411N77t?spm_id_from=333.337.search-card.all.click',
        operate: 'https://space.bilibili.com/2057006251/channel/collectiondetail?sid=437833&ctype=0'
      },
      file: {
        ImageQR
      },
      expand: {
        list: [
          {
            title: '目录',
            image: Image_1
          },
          {
            title: 'DevOps全景图',
            image: Image_2
          },
          {
            title: '初创型小微公司架构',
            image: Image_3
          },
          {
            title: '中型腰部公司架构',
            image: Image_4
          },
          {
            title: '大型头部公司架构',
            image: Image_5
          },
          {
            title: '导言',
            text: '本白皮书针对不同DevOps成熟度的企业，量身推荐了持续集成，持续部署以及持续监控的工具集合，' +
              '希望能帮助广大互联网企业，尤其是中小企业，能快速搭建起自己的效能及运维的平台，助力企业快速交付，在日益激烈的行业竞争中收获技术红利。' +
              '随着云原生技术的迅猛发展，建构在多云或混合云之上的具备弹性伸缩能力的DevOps工具逐渐崭露头角，成为DevOps新的发展趋势。' +
              '星汉未来基于云原生技术研发了具备弹性扩缩容能力的开源算力调度引擎BridgX，' +
              '能够对服务进行指标度量的基础治理引擎CudgX以及提供服务编排、镜像管理等服务的Web云原生基础治理平台SchedulX，' +
              '同时联合周边生态伙伴，为企业提供全方位一站式的工程效率和运维环节解决方案。',
          }
        ]
      }
    };
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}book/devOps/';

.banner {
  overflow: hidden;
  position: relative;
  z-index: 0;
  padding: 0 @padding;
  .bg('@{image}banner.jpg');
  background-size: cover;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    z-index: 0;
    margin: 0 auto;
    padding: 150px 0 70px;
    
    h1.ant-typography {
      .font(left, 54px, @color_white, 50px, true);
    }
    
    h5.ant-typography {
      .font(left, 34px, @color_white, 30px, true);
    }
    
    div.ant-typography {
      display: block;
      position: relative;
      padding: 10px 0;
      .font(left, @font_6+@line, @color_white, @font_6);
      
      &::before {
        content: '';
        display: block;
        .center();
        z-index: -1;
        .bg('@{src_image}page/home/banner_text.png', 110%, 100%, true);
      }
    }
  }
}

.section {
  overflow: hidden;
  position: relative;
  background-color: @color_7;
  
  .container {
    overflow: hidden;
    position: relative;
    max-width: @grid_xl;
    padding: 50px 20px;
    margin: 0 auto;
    border-left: 1px solid fade(@color_black, 10);
    border-right: 1px solid fade(@color_black, 10);
    
    img {
      display: block;
      width: 100%;
    }
    
    h1.ant-typography {
      .font(left, 50px, @color_black, 30px, true);
    }
    
    div.ant-typography {
      display: block;
      .font(justify, 40px, @color_3, 18px);
      text-indent: 2em;
    }
    
    .text {
      max-width: 750px;
      margin: 0 auto;
    }
    
    .qr {
      width: 300px;
      margin: 30px auto;
    }
    
    .button_1 {
      width: auto !important;
      padding: 0 15px !important;
      margin: 30px auto;
    }
  }
}

.box_href {
  text-align: center;
  
  h2.ant-typography {
    margin-bottom: 30px;
    .font(center, 40px, @color_3, 30px);
  }
  
  .button_1 {
    display: inline-block !important;
    width: auto !important;
    padding: 0 15px !important;
    margin: 0 10px 20px !important;
    vertical-align: top;
  }
}

@media screen and (max-width: -1px+@grid_xl) {
  .banner {
    .container {
      padding: 100px 0 50px;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .banner {
    .container {
      h1.ant-typography {
        margin: 0;
        .font(justify, 34px, @color_white, 26px, true);
      }
      
      h5.ant-typography {
        margin: 0 0 20px;
        .font(justify, @font_6+@line, @color_white, @font_6);
      }
      
      div.ant-typography {
        .font(justify, @font_6+@line, @color_white, @font_6);
      }
    }
  }
  
  .section {
    .container {
      h1.ant-typography {
        .font(left, 40px, @color_black, 26px, true);
      }
    }
  }
  
  .box_href {
    h2.ant-typography {
      .font(center, 40px, @color_3, 26px);
    }
  }
}

@media screen and (max-width: -1px+@grid_xs) {
  .banner {
    background-position: center left !important;
  }
}
</style>